<template>
  <l-table :columns="columns" :dataSource="dataSource" height="notset">
  </l-table>
</template>
<script>
export default {
  name: "l-view-table",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    code: String,
    paramFiled: [String, Number],
    ParamJsonList:{

    }
  },
  data() {
    return {
      dataSource: [],
    };
  },
  mounted() {
    this.viewTableData();
  },
  watch: {
    paramFiled() {
      this.viewTableData();
    },
    ParamJsonList(){
      console.log('变化');
    }
  },
  methods: {
    async viewTableData() {
      if (this.paramFiled && this.code) {
        const apiDbsource = window.$api.data.dbsource;
        var obj = {}
        if(this.ParamJsonList){
        
          this.ParamJsonList.forEach(item => {
            var bol = true
            for(var i in this.lr_dataParamsSource){
              if(i == item.f_DefaultValue){
                  obj[item.f_ParamName.slice(1)] = this.lr_dataParamsSource[i]
                  bol= false
              }else{
                if(bol){
                  if((item.f_DataType == 'date' || item.f_DataType == 'datetime') && item.f_NewDefaultValue){
                    obj[item.f_ParamName.slice(1)] = item.f_NewDefaultValue
                  }else{
                    obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
                  }
                }
              }
            }
          })
        }
        var pamdata = {
          queryJson:obj
        }
        const data = await this.$awaitWraper(
          apiDbsource.newGetDataListByParamter(this.code, pamdata)
        );
        this.dataSource = data || [];
      } else {
        this.dataSource = [];
      }
    },
  },
};
</script>